/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

/*
  This class wraps the Overlay Mission Button
 */
import React from 'react';
import { Dialog } from '@mui/material';
import {
  selectOverlayMissionFlightLegListVisible,
  selectOverlayMissionMissionListVisible,
  selectOverlayMissionModalVisible,
} from '../../../../../store';
import { useSelector, shallowEqual } from 'react-redux';
import MissionPlanListContainer from './MissionPlanList/MissionPlanListContainer';
import styled from 'styled-components';
import FlightLegListContainer from './FlightLegList/FlightLegListContainer';

const OverlayMissionDialogContainer = () => {
  const overlayMissionMissionListVisible = useSelector(selectOverlayMissionMissionListVisible, shallowEqual);
  const overlayMissionFlightLegListVisible = useSelector(selectOverlayMissionFlightLegListVisible, shallowEqual);
  const overlayMissionModalVisible = useSelector(selectOverlayMissionModalVisible, shallowEqual);

  return overlayMissionModalVisible ? (
    <StyledDialog maxWidth={false} onClose={() => {}} aria-labelledby="simple-dialog-title" open={true}>
      {overlayMissionMissionListVisible && <MissionPlanListContainer />}
      {overlayMissionFlightLegListVisible && <FlightLegListContainer />}
    </StyledDialog>
  ) : null;
};

export default OverlayMissionDialogContainer;

const StyledDialog = styled(Dialog)`
  min-width: 730px;
  .MuiDialog-paper {
    overflow-y: visible;
  }
`;
